module.exports = __webpack_public_path__ + "a52a8300057c664e7a43cfd003923af3.MP3";